<template>
  <div>
    <div v-if="!isInMonday">
      <Navbar />
    </div>
    <div class="bg-swoosh">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#00c875" fill-opacity="1" d="M0,224L120,197.3C240,171,480,117,720,112C960,107,1200,149,1320,170.7L1440,192L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"></path></svg>
    </div>
    <v-container>
      <div class="d-flex">
        <div class="flex-grow-1">
          <div style="height: 12rem;"></div>
          <div>
            <img src="imgs/logo/gs-logo-circle.png" style="width: 18rem; height: 18rem;" class="soft-shadow" />
            <br />
            <span class="text-h1 font-weight-bold" style="color: var(--color-asphalt);">
              GreenShade
            </span>
          </div>
          <p class="text-h2 font-weight-thin grey--text seperate-words-anim">Helping you upcycle your business</p>
          <a href="https://auth.monday.com/oauth2/authorize?client_id=e31c39b6065da96a67efa1da68b8df1d&response_type=install" target="_blank">
            <img
              alt="Add to monday.com"
              height="42"
              src="https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/uploads/Tal/4b5d9548-0598-436e-a5b6-9bc5f29ee1d9_Group12441.png"
            />
          </a>
          <br />
          <v-btn href="/demo-board" outlined style="color:var(--color-basic_blue)">
            DEMO
          </v-btn>
        </div>
        <div class="d-flex justify-center align-center pa-4" style="min-width: 300px; max-width: 60rem; width: 60rem;">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/4tAzr3mx9xE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <v-divider class="mt-4" />
      <v-btn href="/explore" text class="ma-2" style="color:var(--color-basic_blue)">
        READ MORE
      </v-btn>
      <v-btn href="/features" text class="ma-2" style="color:var(--color-basic_blue)">
        SEE ALL FEATURES
      </v-btn>
    </v-container>
    <div class="fix-to-bottom">
      <Footer />
    </div>
    <div class="bg-gradient">
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default {
  components: {
    Navbar,
    Footer
  },
  computed: {
    ...mapState(["userProfile"]),
    isLoggedIn() {
      return Object.keys(this.userProfile).length > 0;
    },
  },
  async mounted() {
  }
};
</script>

<style scoped>
.bg-swoosh {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
}

.bg-gradient {
  position: absolute;
  bottom: 0px;
  top: 0px;
  right: 0px;
  left: 0px;
  z-index: -9999;
  background-color:hsla(91,100%,80%,0);
  background-image:
  radial-gradient(at 100% 75%, hsla(129,0%,60%,0.33) 0px, transparent 50%),
  radial-gradient(at 4% 94%, hsla(56,0%,92%,1) 0px, transparent 50%);
}

</style>
